const images = {
  logo: require("./logo.png"),
  noImage: require("./no-image.jpg"),
  hekateLogo: require("./hekate.png"),
  ATLogo: require("./AT.png"),
  fundepsLogo: require("./fundeps.png"),
  sanarLogo: require("./Sanar.png"),
  illustrationHome: require("./Illustration-home.png"),
  illustration1: require("./UNI182998.jpg"),
  illustration2: require("./UNI421086.jpg"),
  illustration4: require("./2.png"),
  illustration5: require("./3.png"),
  function1: require("./ai.png"),
  library: require("./library.png"),
  report: require("./reporting.png"),
  protect: require("./protect.png"),
  babyFood: require("./baby-food.png"),
  partnership: require("./partnership.png"),
  notify: require("./notify.png"),
  mongoFlag: require("./flag-of-Mongolia.jpg"),
  ukFlag: require("./UK_flag.png"),
  imgLading: require("./img-landing.png"),
  BY: require("./logo-BY-Laos.png"),
  EU: require("./logo-EU.png"),
  unicef: require("./logo-unicef.png"),
  about1: require("./about1.png"),
  about2: require("./about2.png"),
  about3: require("./about3.png"),
  govLogo: require("./logo-gov.jpg"),
  unicefLogo: require("./logo-unicef-mogo.jpg"),
};

export default images;
